import { render, staticRenderFns } from "./school_oneList.vue?vue&type=template&id=512e11d6&scoped=true"
import script from "./school_oneList.vue?vue&type=script&lang=js"
export * from "./school_oneList.vue?vue&type=script&lang=js"
import style0 from "./school_oneList.vue?vue&type=style&index=0&id=512e11d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e11d6",
  null
  
)

export default component.exports